var React = require('react');

function IconDashboardO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76.6 568.4c-5.1 0-9.4-3.9-10-8.9-1.6-15.4-2.5-31.1-2.5-47 0-247 200.2-447.2 447.2-447.2s447.2 200.2 447.2 447.2c0 15.8-.8 31.5-2.5 47-.5 5.1-4.8 8.9-10 8.9h-50.3c-5.9 0-10.6-5.1-9.9-11 1.5-13.7 2.3-27.6 2.3-41.7C888.3 309.3 721 142 514.6 142S140.9 309.3 140.9 515.7c0 14.1.8 28 2.3 41.7.7 5.9-4 11-9.9 11H76.6zm687.9-112.3c-4.6 0-8.6-3.1-9.8-7.5-28.2-108-126.5-187.7-243.3-187.7-116.8 0-215 79.7-243.3 187.5-1.2 4.4-5.1 7.5-9.7 7.5h-36.9c-6.4 0-11.2-5.9-9.8-12.2C242.8 307.1 365.2 205 511.4 205s268.5 102 299.8 238.8c1.4 6.2-3.3 12.2-9.7 12.2-11.2 0-27.4 0-37 .1zm-198.2-29.8c3.9-15.4 18.8-24.5 33.4-20.4 14.6 4.1 23.2 20 19.3 35.4l-65.1 257.1c23.1 15 38.4 40.8 38.4 70.3 0 46.3-37.5 83.8-83.8 83.8s-83.8-37.5-83.8-83.8c0-43.7 33.5-79.1 76.1-83.1l65.5-259.3zm-20.4 341.1c0-20.9-17-37.9-37.9-37.9s-37.9 17-37.9 37.9 17 37.9 37.9 37.9 37.9-17 37.9-37.9z"}));
}

IconDashboardO.displayName = "IconDashboardO";

IconDashboardO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDashboardO;

IconDashboardO.default = IconDashboardO;
